/* English dictionary: render namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const render = {
  // ---- Card category words (printed on cards; shared by several faces) ----
  'render.category.attack': [ 'Attack' ],
  'render.category.lethal': [ 'Lethal' ],
  'render.category.rescue': [ 'Rescue' ],
  'render.category.interrupt': [ 'Interrupt' ],
  'render.category.powerless': [ 'Powerless' ],
  'render.category.needsTarget': [ 'Needs target' ],
  'render.category.function': [ 'Utility' ],
  // ---- Exception face ----
  'render.face.exceptionHolder': [ 'Drawn by' ],
  // ---- Lore tail on the centered lethal card while dying ----
  'render.dyingLethalLore': [ 'If no one plays [Capture] for you, you are out.' ],
  // ---- Turn queue ----
  'render.turnQueue.handCount': [ { type: 'param', name: 'n' }, ' cards' ],
  'render.turnQueue.pointIt': [ '◂ Click' ],
  // ---- Tracker state legend ----
  'render.legend.discarded': [ 'Discard pile' ],
  'render.legend.inHand': [ 'In hand' ],
  'render.legend.unknown': [ 'Unknown' ],
  // ---- Insert-exception hint ----
  'render.insertHint.title': [ 'Insert position' ],
  'render.insertHint.drawsUntil': [ 'Drawn as the ', { type: 'param', name: 'n' }, 'th card' ],
  'render.insertHint.drawerUnknown': [ 'If no one shuffles, the drawer is unknown' ],
  'render.insertHint.drawerNamed': [ 'If no one shuffles → ', { type: 'param', name: 'name' } ],
  // ---- CardView / face cache (internal assertions) ----
  'render.cardView.textureTooSmall': [ 'Face texture ', { type: 'param', name: 'texW' }, '×', { type: 'param', name: 'texH' }, ' is smaller than the card itself ', { type: 'param', name: 'sizeW' }, '×', { type: 'param', name: 'sizeH' }, ' — are width and height swapped?' ],
  'render.cardView.textureResized': [ 'CardView face texture resized (expected ', { type: 'param', name: 'expectW' }, '×', { type: 'param', name: 'expectH' }, ', got ', { type: 'param', name: 'texW' }, '×', { type: 'param', name: 'texH' }, ') — a size change requires rebuilding the CardView.' ],
  'render.faceCache.badAspect': [ 'Face size ', { type: 'param', name: 'w' }, '×', { type: 'param', name: 'h' }, ' is not the standard card aspect ratio — face painters must not decide their own shape; use metrics.faceSize().' ],
  // ---- Motion stepper (internal warning) ----
  'render.motion.error': [ '[motion] An animation threw; it was removed from the per-frame queue' ],
  // ---- Card rendering bench (debug page) ----
  'render.lab.emptyPack': [ 'No cards in the base pack' ],
  'render.lab.title': [ 'Ivory Roulette ivory-roulette' ],
  'render.lab.subtitle': [ 'Card rendering bench · fake perspective parameter reference (static demo, no parameter controls yet)' ],
  'render.lab.row.yaw': [ 'yaw — rotate around Y (horizontal trapezoid): positive tilts the right side back' ],
  'render.lab.row.pitch': [ 'pitch — rotate around X (vertical trapezoid): positive tilts the top back' ],
  'render.lab.row.perspective': [ 'perspective — camera distance (in long-edge units): smaller is more extreme (pitch fixed at 0.45)' ],
  'render.lab.row.combo': [ 'combo — roll + pitch together: hand fan (r = roll, p = pitch)' ],
  'render.lab.footer': [ 'Each row varies one parameter · face cache: ', { type: 'param', name: 'cached' }, ' FBOs (not one per card) · face ', { type: 'param', name: 'w' }, '×', { type: 'param', name: 'h' } ],
  'render.lab.stage.field': [ '① Scalar field (unmapped)' ],
  'render.lab.stage.mapped': [ '① Scalar field + mapping' ],
  'render.lab.stage.halftone': [ '① + ② Halftone (all on)' ],
  'render.lab.hint': [ { type: 'param', name: 'stage' }, ' · click to drop a ripple (Shift = swirl) · Space randomizes · 1/2/3 switch stage · D dying' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
render satisfies Record<string, TextSpec>;
export default render;
